import {FullScreenContainer, ScreenParameters} from '@gongxigames/framework/core';
import {PopupFaderImgConfig, PopupFaderConfig} from '@gongxigames/framework/slot/types';
import {Fader, CallBack} from '@gongxigames/framework/slot/modules/genericPopup/fader/Fader';

export class FaderImage extends Fader {
    static testSettingsType(config: PopupFaderConfig): boolean {
        return !!(config as PopupFaderImgConfig).img;
    }

    private fullscreenContainer?: FullScreenContainer;

    public show(cb: CallBack): void {
        const { container, config, updater, objectBuilder, displayObjectUtils } = this;
        const { alpha = 1, img, height, width } = config as PopupFaderImgConfig;
        const image = objectBuilder.buildImage({src: img});
        const bounds = image.getBounds();
        const duration = this.getFadeDuration();

        this.fullscreenContainer = displayObjectUtils.createFullScreenContainer({
            contentHeight: height || bounds.height,
            contentWidth: width || bounds.width
        });

        this.fullscreenContainer.addChild(image);
        this.fullscreenContainer.alpha = 0;

        container.addChild(this.fullscreenContainer);

        updater
            .addTween(this.fullscreenContainer)
            .to({ alpha }, duration)
            .start()
            .onComplete(cb);

        this.container.visible = true;
    }

    public resize(screenParams: ScreenParameters): void {
        this.fullscreenContainer?.resize(screenParams);
    }
}
